export const colorPallet = {
  dark100: '#0D161F',
  dark90: '#121E2B',
  dark80: '#1B2B3C',
  dark70: '#253A55',
  neutralHigh: '#3D5977',
  neutralMid: '#85A0BD',
  neutralLow: '#A5BCD5',
  neutralLight: '#BFD0E0',
  greyD9: '#D9D9D9',
  greyF3: '#F3F3F3',
  greyBa: '#BABABA',
  white: '#fff',
  primaryNeon: '#BEFF00',
  primaryNeonLogo: '#ABE500',
  primaryPurple: '#A460FF',
  primaryYellow: '#FFE600',
  semRed: '#FF6F50',
  semGreen: '#00ED26',
  lightGreen: '#E2FCDE',
  viper700: '#00C50D',
  semBlue: '#00C1FF',
  lightBlue: '#DEF5FF',
  semMale: '#298CFF',
  semFemale: '#FF29AA'
};
